

















import { defineComponent } from '@vue/composition-api';
import TranslationIcon from '@tt4b/ttam-assets/src/svgs/creative/smart-translate-btn-icon.svg';
const name = 'creative-tool-smart-translation';
export default defineComponent({
  name,
  components: {
    TranslationIcon,
  },
  setup() {
    return {
      name,
    };
  },
});
